import { gsap } from './app/gsap';
import { ScrollTrigger } from './app/ScrollTrigger.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.js';
// import { ScrollSmoother } from './app/ScrollSmoother.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// ScrollSmoother.create({
// 	smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
// 	effects: true, // looks for data-speed and data-lag attributes on elements
// 	smoothTouch: 0.1 // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// });
ScrollTrigger.config({ anticipatePin: 1 });
const debouncedRefresh = gsap.delayedCall(0.12, () => ScrollTrigger.refresh()).pause();
const queueRefresh = () => debouncedRefresh.restart(true);
const tlMap = new WeakMap()
const paraFX = new WeakMap();

const announcementBar = document.querySelector('.site-announcement');
let _lastScrollY = window.scrollY || window.pageYOffset;


function enableParagraphScrollFX(panel, targets) {
  const entries = targets.map(el => {
    gsap.set(el, { opacity: 0.1, y: 8});

    const tween = gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "power1.out",
      paused: true
    });

    const st = ScrollTrigger.create({
      trigger: el,
      start: "top 85%",
      end: "bottom 10%",
      onEnter: () => tween.play(),
      onEnterBack: () => tween.play(),     
      onLeaveBack: () => tween.reverse(),  
      invalidateOnRefresh: true
    });

    return { st, tween };
  });

  paraFX.set(panel, entries);
}

function disableParagraphScrollFX(panel) {
  const entries = paraFX.get(panel);
  if (!entries) return;
  entries.forEach(({ st, tween }) => { st.kill(); tween.kill(); });
  paraFX.delete(panel);
}

function buildTimeline(panel) {
  panel.hidden = false;

  gsap.set(panel, { height: "auto" });
  const targetH = panel.offsetHeight;

  gsap.set(panel, { height: 0 });

  const items = gsap.utils.toArray(panel.querySelectorAll("h2,h4,h6,p"));
  const targets = items.length ? items : gsap.utils.toArray(panel.children);

  gsap.set(targets, { opacity: 0, y: 8 });

  const tl = gsap.timeline({
    paused: true,
    defaults: { ease: "power1.out" },
    onUpdate: ScrollTrigger.update,
    onComplete: () => {
      panel.style.height = "auto";
      enableParagraphScrollFX(panel, targets); 
      queueRefresh();
    },
    onReverseStart: () => {
      disableParagraphScrollFX(panel);
      gsap.set(targets, { opacity: 0, y: 8 });
      gsap.set(panel, { height: panel.offsetHeight });
    },
    onReverseComplete: () => {
      panel.hidden = true;
      queueRefresh();
    }
  });

  tl.to(panel, { height: targetH, duration: 0.6 }, 0);

  return tl;
}

function makeScrollingEchoHeading(selector, {
  repeats = 3,        // clones each side
  gap = '2rem',       // spacing between words
  dimOpacity = 0.1,   // opacity for echoes
  travel = 120        // px left→right scroll travel
} = {}) {

  gsap.utils.toArray(selector).forEach(h => {
    const text = (h.textContent || '').trim();
    if (!text) return;

    // Build track with dimmed clones around a single "main" word
    const track = document.createElement('span');
    track.className = 'glide-track';
    track.style.setProperty('--glide-gap', gap);

    // left echoes
    for (let i = repeats; i > 0; i--) {
      const s = document.createElement('span');
      s.className = 'glide-word';
      s.setAttribute('aria-hidden', 'true');
      s.style.opacity = dimOpacity;
      s.textContent = text;
      track.appendChild(s);
    }

    // main word (fully opaque, accessible)
    const main = document.createElement('span');
    main.className = 'glide-word';
    main.textContent = text;
    track.appendChild(main);

    // right echoes
    for (let i = 0; i < repeats; i++) {
      const s = document.createElement('span');
      s.className = 'glide-word';
      s.setAttribute('aria-hidden', 'true');
      s.style.opacity = dimOpacity;
      s.textContent = text;
      track.appendChild(s);
    }

    h.textContent = '';
    h.appendChild(track);

    gsap.fromTo(
	h.querySelector('.glide-track'),
	{ xPercent: 15 },            
	{
		xPercent: -15,              
		ease: 'none',
		scrollTrigger: {
		trigger: h,
		start: 'top bottom',
		end: 'bottom top',
		scrub: true,
		invalidateOnRefresh: true
		}
	}
	);

  });
}


window.addEventListener('scroll', () => {
	const scrollY = window.scrollY || window.pageYOffset;
	const viewportHeight = window.innerHeight;
	const docHeight = document.documentElement.scrollHeight;

	const remaining = docHeight - (scrollY + viewportHeight);

	if (scrollY > 1000) {
		document.body.classList.add('hide-nav');
	} else {
		document.body.classList.remove('hide-nav');
	}
	if (remaining < 1000) {
		document.body.classList.add('hide-next');
	} else {
		document.body.classList.remove('hide-next');
	}
	if (announcementBar) {
		const goingDown = scrollY > _lastScrollY;
		const threshold = 50; // px before we start hiding on scroll down
		if (scrollY <= threshold) {
			// At or near top: always show
			announcementBar.classList.remove('scrolled');
		} else if (goingDown) {
			// Scrolling down: hide
			announcementBar.classList.add('scrolled');
		} else {
			// Scrolling up: show
			announcementBar.classList.remove('scrolled');
		}
	}

_lastScrollY = scrollY;
});

//const nav_items = document.querySelector('.site-navigation');
if (typeof nav_items !== "undefined") {
	const nav_section = document.querySelector('.scroll-nav');
	if (nav_section) {
		nav_items.forEach((item) => {
			const a = document.createElement('a');
			a.href = `#${ item.link }`;
			a.textContent = item.label;
			a.classList.add('nav-link');
			nav_section.appendChild(a);
			if (item.sub_nav) {
				const subItems = document.createElement("div");
				item.sub_nav.forEach(subItem => {
					const subA = document.createElement('a');
					subA.href = `#${ subItem.link }`;
					subA.textContent = subItem.label;
					subA.classList.add('nav-link');
					subItems.appendChild(subA);
				});
				nav_section.appendChild(subItems);
			}
		});
		const a = document.createElement('a');
		a.href = `#footer`;
		a.textContent = 'Studio Seaview';
		a.classList.add('nav-link');
		nav_section.appendChild(a);
	}
}

window.addEventListener('load', () => {
	setTimeout(() => {
		document.body.classList.add('loaded');
	}, 100);

		if (document.querySelector('.rank-math-list')) {
			const faqList = document.querySelector('.rank-math-list');

			if (!faqList.querySelector('.rank-math-list-item--dummy')) {
				const dummyItem = document.createElement('div');
				dummyItem.className = 'rank-math-list-item rank-math-list-item--dummy';
				dummyItem.style.visibility = 'hidden';
				dummyItem.style.pointerEvents = 'none';

				dummyItem.innerHTML = `
					<div class="rank-math-question"></div>
					<div class="rank-math-answer"></div>
				`;

				faqList.appendChild(dummyItem);
			}
		}

	document.querySelectorAll('.program-section--introduction').forEach((_section) => {
		const direction = _section.dataset.scrollAxis;
		const heading = _section.querySelector('.intro-heading');
		const introImage = _section.querySelectorAll('.intro-image');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: _section,
				id: _section.id,
				scrub: true,
				pin: true,
				pinSpacing: false,
				end: 'bottom+=750 top'
			}
		});

		switch (direction) {
			case 'horizontal' :
				tl.to(heading, {
					xPercent: -200,
					willChange: 'transform',
					duration: 2
				}, 'start');

				break;
			case 'vertical' :

				break;
		}

		tl.to(introImage, {
			scale: 1.5,
			willChange: 'transform',
			duration: 2
		}, 'start');

		tl.to(introImage, {
			opacity: 0,
			willChange: 'opacity',
			duration: 5
		});
	});

	
	gsap.utils.toArray('.note--multiple__trigger').forEach(btn => {
		const panel = document.getElementById(btn.getAttribute("aria-controls"));
		gsap.set(panel, { height: 0 });

		btn.addEventListener("click", () => {
			btn.classList.toggle("note--multiple__trigger--expanded");
			const isOpen = btn.getAttribute("aria-expanded") === "true";
			btn.setAttribute("aria-expanded", String(!isOpen));

			if (!isOpen) {
				const tl = buildTimeline(panel);
				tlMap.set(panel, tl);
				tl.play(0);
			} else {
				const tl = tlMap.get(panel);
				if (tl) {
					tl.reverse();
				}  else {
					panel.hidden = false;
					gsap.to(panel, {
						height: 0,
						duration: 0.25,
						ease: "power1.in",
						onUpdate: ScrollTrigger.update,
						onComplete: () => { panel.hidden = true; queueRefresh(); }
					});
				}
			}
		});
	});


	document.querySelectorAll('.program-section--directors_or_writers_note').forEach((_section) => {
		const direction = _section.dataset.scrollAxis;
		const header = _section.querySelector('.note-profile');
		const noteCopy = _section.querySelector('.note-copy');
		// Ensure the section wrapper height matches the full content height
		const content = _section.querySelector('.scroll-panel__content');
		const contentHeight = content.scrollHeight;
		_section.style.height = contentHeight + 'px';

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: _section,
				start: 'top top',
				end: '+=2000',
				scrub: true,
				pin: true,
				anticipatePin: 1
			}
		});

		switch (direction) {
			case 'horizontal':
				tl.from(header, {
					xPercent: -200,
					duration: 0.6,
					ease: 'power2.out'
				}, 0);

				tl.from(noteCopy, {
					xPercent: -200,
					duration: 0.6,
					ease: 'power2.out'
				}, '+=0.2');
				break;
		}

		if (noteCopy) {
			ScrollTrigger.create({
				trigger: noteCopy,
				start: 'top top',
				end: 'bottom top',
				onEnter: () => document.body.classList.add('show-note-gradients'),
				onEnterBack: () => document.body.classList.add('show-note-gradients'),
				onLeave: () => document.body.classList.remove('show-note-gradients'),
				onLeaveBack: () => document.body.classList.remove('show-note-gradients')
			});
		}
	});

	document.querySelectorAll('.program-section--call_to_bar').forEach((_section) => {
		const direction = 'horizontal';
		const logo = _section.querySelector('.bar-logo');
		const intro = _section.querySelectorAll('.bar-intro');

		const tl = gsap.timeline({
			scrollTrigger: {
				id: _section.id,
				trigger: _section,
				scrub: true,
				pin: true,
				start: '0',
				end: '+=2000',
				anticipatePin: 1
			}
		});

		switch (direction) {
			case 'horizontal':
				// Animate logo first
				tl.to(logo, {
					xPercent: -200,
					willChange: 'transform',
					duration: 0.4
				}, 0);

				tl.to(intro, {
					x: 0,
					willChange: 'transform',
					duration: 0.4
				}, '-=0.3');

				tl.to(intro, {
					filter: 'blur(10px)',
					opacity: 0.5,
					duration: 0.1
				});
				tl.to(intro, {
					opacity: 0,
					duration: 0.1
				});
				break;
		}
	});

	document.querySelectorAll('.program-section--media_carousel').forEach((section) => {
	const direction = section.dataset.scrollAxis;
	const scrollTrack = section.querySelector('.scroll-track');
	const credit = section.querySelector('.photo-credit'); // your absolutely positioned credit
	if (!scrollTrack) return;

	const viewportWidth = () => section.offsetWidth;
	const totalScrollWidth = () => scrollTrack.scrollWidth;

	// helper: toggle credit when track spans the viewport
	const updateCreditVisibility = () => {
		if (credit) {
			const rect = scrollTrack.getBoundingClientRect();
			const host = section.getBoundingClientRect();
			const leftEdge = rect.left - host.left;          
			const rightEdge = rect.right - host.left;        
			const vw = host.width;

			const show = leftEdge <= 0 && leftEdge > ((totalScrollWidth() - viewportWidth()) * -1);
			credit.classList.toggle('is-visible', show);
		}
	};

	if (direction === 'horizontal') {
		const scrollDistance = () => totalScrollWidth() + viewportWidth();
		gsap.set(scrollTrack, { x: viewportWidth() });

		gsap.to(scrollTrack, {
		x: () => `-${scrollDistance()}px`,
		ease: 'none',
		scrollTrigger: {
			trigger: section,
			id: section.id,
			start: 'top top',
			end: () => `+=${scrollDistance()}`,
			scrub: true,
			pin: true,
			anticipatePin: 1,
			onUpdate: updateCreditVisibility,
			onRefresh: updateCreditVisibility
		}
		});
	}

	if (direction === 'horizontal-alt') {
		const scrollDistance = () => totalScrollWidth();
		const endScrollDistance = () => scrollDistance() + viewportWidth();
		gsap.set(scrollTrack, { x: -scrollDistance() });

		gsap.to(scrollTrack, {
		x: () => viewportWidth(),
		ease: 'none',
		scrollTrigger: {
			trigger: section,
			id: section.id,
			start: 'top top',
			end: () => `+=${endScrollDistance()}`,
			scrub: true,
			pin: true,
			anticipatePin: 1,
			onUpdate: updateCreditVisibility,
			onRefresh: updateCreditVisibility
		}
		});
	}

	// Also listen to resize to keep things correct
	ScrollTrigger.addEventListener('refreshInit', updateCreditVisibility);
	// Initial state
	updateCreditVisibility();
	});


	document.querySelectorAll('.program-section--seaview_end_card').forEach((section) => {
		const video = section.querySelector('video');
		const copy = section.querySelector('.seaview-end-copy');

		gsap.set(copy, { autoAlpha: 0 });
		gsap.to(copy, { autoAlpha: 1, duration: 0.2 }); // sync with video fade out
	});

	if (document.querySelector('.program-header--close')) {
		document.querySelector('.program-header--close').addEventListener('click', () => {
			document.querySelector('.program-header--navigation').classList.remove('program-header--navigation--active');
		});
	}
	if (document.querySelector('.program-header--button')) {
		document.querySelector('.program-header--button').addEventListener('click', () => {
			document.querySelector('.program-header--navigation').classList.add('program-header--navigation--active');
		});
	}

	document.querySelectorAll('.scroll-nav a').forEach((_a) => {
		_a.addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.program-header--navigation').classList.remove('program-header--navigation--active');

			if (!_a.href) {
				return;
			}

			const id = _a.href.split('#')[ 1 ];

			const trigger = ScrollTrigger.getById(id);
			if (!trigger) {
				const el = document.getElementById(id);
				if (el && el.ariaExpanded && el.ariaExpanded == 'false') {
					el.click();
				}
				return;
			}
			
			const percentage = parseInt(trigger.trigger.dataset.scrollPercentage, 10);
			const targetScroll = trigger.start + (trigger.end - trigger.start) * (percentage * 0.01);

			gsap.to(window, {
				scrollTo: targetScroll,
				duration: 0.5,
				ease: 'power3.out'
			});
		});
	});

	document.querySelectorAll('a[href*="#"]').forEach(link => {
		link.addEventListener('click', e => {
			const hash = link.href.split('#')[1];
			if (!hash) return;
			const target = document.getElementById(hash);
			if (!target) return;
			e.preventDefault();
			gsap.to(window, {
				scrollTo: { y: target, offsetY: 80 },
				duration: 0.8,
				ease: 'power3.out'
			});
		});
	});

	document.querySelectorAll(".glide-heading").forEach(heading => {

		makeScrollingEchoHeading(".glide-heading", {
			repeats: 6,
			gap: '2.5rem',
			dimOpacity: 0.1,
			travel: 140
			});

		})

	const button = document.getElementById('next-section');
	if (button) {
		const sections = [...document.querySelectorAll('section[id^="section-"]')];
		button.addEventListener('click', () => {
			let currentIndex = -1;

			sections.forEach((section, i) => {
				const rect = section.getBoundingClientRect();
				if (rect.top <= window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
					currentIndex = i;
				}
			});

			let nextSection = null;
			for (let i = currentIndex + 1; i < sections.length; i ++) {
				if (!parseInt(sections[ i ].dataset.skip, 10)) {
					nextSection = sections[ i ];
					break;
				}
			}

			if (!nextSection) {
				return;
			}

			const scrollPercentage = parseInt(nextSection.dataset.scrollPercentage || '0', 10);
			const trigger = ScrollTrigger.getById(nextSection.id);

			let targetY;

			if (trigger && scrollPercentage > 0) {
				targetY = trigger.start + (trigger.end - trigger.start) * (scrollPercentage * 0.01);
			} else {
				targetY = nextSection.offsetTop;
			}

			gsap.to(window, {
				scrollTo: targetY,
				duration: 0.5,
				ease: 'power3.out'
			});
		});
	}
});


